/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const recipients = {
  index: 		r => require.ensure([], () => r(require('./components/recipient')), 'recipient-bundle'),
	imports: 	r => require.ensure([], () => r(require('./components/import')), 	'recipient-bundle'),
	edit: 	r => require.ensure([], () => r(require('./components/edit')), 	'recipient-bundle'),
	suppressionlist: 	r => require.ensure([], () => r(require('./components/suppressionlist')), 	'recipient-bundle'),
	UploadCsv: 	r => require.ensure([], () => r(require('./components/upload_csv')), 	'recipient-bundle'),
	MatchFields: 	r => require.ensure([], () => r(require('./components/match_fields')), 	'recipient-bundle'),
	Organize: 	r => require.ensure([], () => r(require('./components/organize')), 	'recipient-bundle'),
	Review: 	r => require.ensure([], () => r(require('./components/review')), 	'recipient-bundle'),
	Thanks: 	r => require.ensure([], () => r(require('./components/thanks')), 	'recipient-bundle'),
	Lists: 	r => require.ensure([], () => r(require('./components/lists')), 	'recipient-bundle'),
	Group: 	r => require.ensure([], () => r(require('./components/manage_groups')), 	'recipient-bundle'),
	ouSetting: 	r => require.ensure([], () => r(require('./components/ou_setting')), 	'recipient-bundle'),
	suppression:{
		imports: 	r => require.ensure([], () => r(require('./components/suppressionimport')), 	'recipient-bundle'),
	}
};

export default [
	{
		name: 'recipients.ouSetting',
		path: '/recipients/ou-settings',
		component: recipients.ouSetting,
  },  
	{
		name: 'recipients.upload_csv',
		path: '/recipients/upload-csv',
		component: recipients.UploadCsv,
  },
  {
		name: 'recipients.match_fields',
		path: '/recipients/match-fields',
		component: recipients.MatchFields,
  },
  {
		name: 'recipients.organize',
		path: '/recipients/organize',
		component: recipients.Organize,
  },
  {
		name: 'recipients.review',
		path: '/recipients/review',
		component: recipients.Review,
  },
  {
		name: 'recipients.thanks',
		path: '/recipients/thanks',
		component: recipients.Thanks,
  },
  {
		name: 'recipients.lists',
		path: '/recipients/lists',
		component: recipients.Lists,
  },
  {
		name: 'recipients.manage_groups',
		path: '/recipients/manage-groups',
		component: recipients.Group,
  },
  
  {
		name: 'recipients',
		path: '/recipients',
		component: recipients.index,
  },
  {
		name: 'recipients.group',
		path: '/group/recipients/:id',
		component: recipients.index,
  },
  {
		name: 'suppression',
		path: '/suppression',
		component: recipients.suppressionlist,
  },
  {
		name: 'recipients.imports',
		path: '/import/recipients',
		component: recipients.imports,
  },
  {
		name: 'recipients.suppression.imports',
		path: '/imports/suppression',
		component: recipients.suppression.imports,
  },
  {
		name: 'recipients.edit',
		path: '/recipients/:id',
		component: recipients.edit,
  },
	

]





// WEBPACK FOOTER //
// ./src/app/recipient/routes.js